<template>
  <div class="search">
    <el-tabs type="border-card">
      <el-tab-pane label="Search">
        <el-input placeholder="Search..." v-model="searchkey">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch">Search</el-button>
          <!-- <template slot="append">Search<i class="fa fa-circle-right"></i></template> -->
        </el-input>
        <el-card class="box-card mt20" shadow="never" v-if="isShowResult">
          <div slot="header" class="clearfix textLeft">
            <span><i class="fa fa-cogs fs14" /> Super Project Information List</span>
          </div>
          <div class="textLeft">
            Search: <el-input size="medium" v-model="supprosekey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearchsuppro">Search</el-button>
            <el-table
              class="mt10"
              empty-text="No Data"
              border
              stripe
              v-loading="loadingsup"
              :data="supprojectData"
              style="width: 100%"
              :row-key="getRowKeyssup"
              @sort-change="handleSortsup"
              :expand-row-keys="expandssup"
              @expand-change="handleExpandsup">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                    border
                    v-loading="expsuploading"
                    :data="props.row.suptableData"
                    style="width: 100%">
                    <!-- <el-table-column
                      prop=""
                      label=" "
                      width="50">
                    </el-table-column> -->
                    <el-table-column
                      prop="project_title_english"
                      label="Project Title"
                      width="210"
                      :show-overflow-tooltip="isOverflow">
                      <template slot-scope="scope">
                        <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">
                          {{scope.row.project_title_english}}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="project_id"
                      label="Project ID"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="submission_type"
                      label="Submission Type"
                      width="130"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="px_id"
                      label="PX ID"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      label="Publication"
                      prop="pubmed_id"
                      sortable
                      :show-overflow-tooltip="isOverflow">
                      <template slot-scope="scope">
                        <span>
                          <a :href="publictionUrl+scope.row.pubmed_id" target="_blank">{{scope.row.pubmed_id}}</a>
                          {{scope.row.reference}}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="submitter"
                      label="Submitter"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="lab_header"
                      label="Lab Head"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="institution_english"
                      label="Institution"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="sub_count"
                      label="Subproject Count"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="submit_time"
                      label="Release Date"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column
                label="SuperProject Name"
                prop="sproject_name"
                sortable
                :show-overflow-tooltip="isOverflow">
                <template slot-scope="scope">
                  <span class="tablelink" @click="handlesupProurl(scope.row.sproject_id)">
                    {{scope.row.sproject_name}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="SuperProject ID"
                prop="sproject_id"
                width="160"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Lable"
                prop="sproject_label"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Description"
                prop="description"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Project Count"
                prop="pro_count"
                width="150"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :total="allNumsup"
              :page-size="pageSizesup"
              @current-change="handleChangepagesup"
              class="pagination mb10">
            </el-pagination>
          </div>
        </el-card>
        <el-card class="box-card mt20" shadow="never" v-if="isShowResult">
          <div slot="header" class="clearfix textLeft">
            <span><i class="fa fa-cogs fs14" /> Project Information List</span>
          </div>
          <div class="textLeft">
            Search: <el-input size="medium" v-model="prosekey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearchpro">Search</el-button>
            <el-table
              class="mt10"
              empty-text="No Data"
              border
              stripe
              height="500"
              v-loading="loading"
              :data="projectData"
              style="width: 100%"
              :row-key="getRowKeys"
              @sort-change="handleSort"
              :expand-row-keys="expands"
              @expand-change="handleExpand">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                    border
                    v-loading="subloading"
                    :data="props.row.subtableData"
                    style="width: 100%">
                    <!-- <el-table-column
                      prop=""
                      label=" "
                      width="50">
                    </el-table-column> -->
                    <el-table-column
                      prop="subtitle_en"
                      label="Subproject Title"
                      width="210"
                      :show-overflow-tooltip="isOverflow">
                      <template slot-scope="scope">
                        <span>
                          <a :href="subpnameUrl+scope.row.subproject_id">{{scope.row.subtitle_en}}</a>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="subproject_id"
                      label="Subproject ID">
                    </el-table-column>
                    <el-table-column
                      prop="px_id"
                      label="PXID">
                    </el-table-column>
                    <el-table-column
                      prop="species"
                      label="Species">
                    </el-table-column>
                    <el-table-column
                      prop="instrument"
                      label="Instrument"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="fileCount"
                      label="File Count (size)">
                    </el-table-column>
                    <el-table-column
                      prop="submit_time"
                      label="Release Date">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column
                label="Project Title"
                prop="project_title_english"
                width="200"
                sortable
                :show-overflow-tooltip="isOverflow">
                <template slot-scope="scope">
                  <span class="tablelink" @click="handleProurl(scope.row.project_id)">
                    {{scope.row.project_title_english}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="ProjectID"
                prop="project_id"
                width="122"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Submission Type"
                prop="submission_type"
                width="104"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="PXID"
                prop="px_id"
                width="98"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Publication"
                prop="pubmed_id"
                sortable
                :show-overflow-tooltip="isOverflow">
                <template slot-scope="scope">
                  <span>
                    <a :href="publictionUrl+scope.row.pubmed_id" target="_blank">{{scope.row.pubmed_id}}</a>
                    {{scope.row.reference}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="Submitter"
                prop="submitter"
                width="114"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Lab Head"
                prop="lab_header"
                width="120"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Institution"
                prop="institution_english"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Subproject Count"
                prop="sub_count"
                width="100"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Releasedate"
                prop="submit_time"
                width="130"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :total="allNum"
              :page-size="pageSize"
              @current-change="handleChangepage"
              class="pagination mb10">
            </el-pagination>
          </div>
        </el-card>
        <el-card class="box-card mt20" shadow="never" v-if="isShowResult">
          <div slot="header" class="clearfix textLeft">
            <span><i class="fa fa-cogs fs14" /> Subproject Information List</span>
          </div>
          <div class="textLeft">
            Search: <el-input size="medium" v-model="subprosekey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearchsub">Search</el-button>
            <el-table
              height="500"
              class="mt10"
              empty-text="No Data"
              :data="subprojectData"
              border
              stripe
              v-loading="loadingsub"
              @sort-change="handleSortsub"
              style="width: 100%">
              <el-table-column
                sortable
                :show-overflow-tooltip="isOverflow"
                prop="subtitle_en"
                label="Subproject">
                <template slot-scope="scope">
                  <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">{{scope.row.subtitle_en}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Subproject ID"
                prop="subproject_id"
                width="140"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="PXID"
                prop="px_id"
                width="140"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Species"
                prop="species"
                width="130"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                prop="instrument"
                label="Instrument"
                width="160">
              </el-table-column>
              <el-table-column
                prop="fileCount"
                label="File Count (size)"
                width="160">
              </el-table-column>
              <el-table-column
                prop="submit_time"
                label="Release Date"
                width="160"
                sortable>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next, jumper"
              :total="allNumsub"
              :page-size="pageSizesub"
              @current-change="handleChangepagesub"
              class="pagination mb10">
            </el-pagination>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Advanced Search">
        <div style="margin-top: 15px;" class="textLeft">
          <!-- <el-select v-model="search1_1" placeholder="All Fields" class="searchcss mb10" disabled>
            <el-option label="All Fields" value="1"></el-option>
          </el-select> -->
          <div v-for="(item, index) in searchItems" :key="index" class="mb10" style="display: flex">
            <el-select v-model="search1_1" placeholder="All Fields" class="searchcss" v-show="item.isShowAll" disabled>
              <el-option label="All Fields" value="1"></el-option>
            </el-select>
            <el-select v-model="item.searchway" class="searchcss" v-show="item.isShowway">
              <el-option
                v-for="item in searchWayOpt"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="item.searchfile" placeholder="All Fields" class="searchcss" @change="handleKind(item,index)">
              <el-option
                v-for="item in allFileOpt"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="item.searchSele" placeholder="Please Select" class="selwidth" v-show="item.isShowsele">
              <el-option
                v-for="item in SeleOpt"
                :key="item.object_id"
                :label="item.object_name"
                :value="item.object_id">
              </el-option>
            </el-select>
            <el-input placeholder="Search..." v-model="item.searchinput" v-show="!item.isShowsele" class="input-with-select inputcss mr5" />
            <el-button type="primary" size="small" @click="handleDele1(index)" v-show="item.isShowway">Delete<i class="el-icon-close el-icon--right"></i></el-button>
          </div>
          <el-card shadow="never" class="mt10 cardbg mb20">
            <el-row>
              <el-col :span="12">
                <div class="tipdiv">
                  <span class="tipcss">Metadata Search</span> (Species,Tissue etc.)<br />You could enter more than one pair of type and value below to conduct this search.
                </div>
              </el-col>
              <el-col :span="12" class="textRight">
                <el-button type="primary" @click="handleAdd1">Add<i class="el-icon-plus el-icon--right"></i></el-button>
                <el-button type="primary" @click="handleReset1">Reset<i class="el-icon-close el-icon-right"></i></el-button>
                <el-button type="primary" @click="handleSearch1">Search<i class="el-icon-search el-icon--right"></i></el-button>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card mt20" shadow="never" v-show="isShowSup">
            <div slot="header" class="clearfix textLeft">
              <span><i class="fa fa-cogs fs14" /> Super Project Information List</span>
            </div>
            <div class="textLeft">
              Search: <el-input size="medium" v-model="supprosekey2" placeholder="" class="searchInput mr5" clearable></el-input>
              <el-button class="submitbtn" @click="handleSearchsuppro2">Search</el-button>
              <el-table
                class="mt10"
                empty-text="No Data"
                border
                stripe
                v-loading="loadingsup2"
                :data="supprojectData2"
                style="width: 100%"
                :row-key="getRowKeyssup2"
                @sort-change="handleSortsup2"
                :expand-row-keys="expandssup2"
                @expand-change="handleExpandsup2">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      border
                      v-loading="expsuploading2"
                      :data="props.row.suptableData2"
                      style="width: 100%">
                      <!-- <el-table-column
                        prop=""
                        label=" "
                        width="50">
                      </el-table-column> -->
                      <el-table-column
                        prop="project_title_english"
                        label="Project Title"
                        width="210"
                        :show-overflow-tooltip="isOverflow">
                        <template slot-scope="scope">
                          <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">
                            {{scope.row.project_title_english}}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="project_id"
                        label="Project ID"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        prop="submission_type"
                        label="Submission Type"
                        width="130"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        prop="px_id"
                        label="PX ID"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        label="Publication"
                        prop="pubmed_id"
                        sortable
                        :show-overflow-tooltip="isOverflow">
                        <template slot-scope="scope">
                          <span>
                            <a :href="publictionUrl+scope.row.pubmed_id" target="_blank">{{scope.row.pubmed_id}}</a>
                            {{scope.row.reference}}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="submitter"
                        label="Submitter"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        prop="lab_header"
                        label="Lab Head"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        prop="institution_english"
                        label="Institution"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        prop="sub_count"
                        label="Subproject Count"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        prop="submit_time"
                        label="Release Date"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column
                  label="SuperProject Name"
                  prop="sproject_name"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                  <template slot-scope="scope">
                    <span class="tablelink" @click="handlesupProurl(scope.row.sproject_id)">
                      {{scope.row.sproject_name}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="SuperProject ID"
                  prop="sproject_id"
                  width="160"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Lable"
                  prop="sproject_label"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Description"
                  prop="description"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Project Count"
                  prop="pro_count"
                  width="150"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :total="allNumsup2"
                :page-size="pageSizesup2"
                @current-change="handleChangepagesup2"
                class="pagination mb10">
              </el-pagination>
            </div>
          </el-card>
          <el-card class="box-card mt20" shadow="never" v-show="isShowPro">
            <div slot="header" class="clearfix textLeft">
              <span><i class="fa fa-cogs fs14" /> Project Information List</span>
            </div>
            <div class="textLeft">
              Search: <el-input size="medium" v-model="prosekey2" placeholder="" class="searchInput mr5" clearable></el-input>
              <el-button class="submitbtn" @click="handleSearchpro2">Search</el-button>
              <el-table
                class="mt10"
                empty-text="No Data"
                border
                stripe
                height="500"
                v-loading="loading2"
                :data="projectData2"
                style="width: 100%"
                :row-key="getRowKeys2"
                @sort-change="handleSort2"
                :expand-row-keys="expands2"
                @expand-change="handleExpand2">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      border
                      v-loading="subloading2"
                      :data="props.row.subtableData2"
                      style="width: 100%">
                      <!-- <el-table-column
                        prop=""
                        label=" "
                        width="50">
                      </el-table-column> -->
                      <el-table-column
                        prop="subtitle_en"
                        label="Subproject Title"
                        width="210"
                        :show-overflow-tooltip="isOverflow">
                        <template slot-scope="scope">
                          <span>
                            <a :href="subpnameUrl+scope.row.subproject_id">{{scope.row.subtitle_en}}</a>
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="subproject_id"
                        label="Subproject ID">
                      </el-table-column>
                      <el-table-column
                        prop="px_id"
                        label="PXID">
                      </el-table-column>
                      <el-table-column
                        prop="species"
                        label="Species">
                      </el-table-column>
                      <el-table-column
                        prop="instrument"
                        label="Instrument"
                        :show-overflow-tooltip="isOverflow">
                      </el-table-column>
                      <el-table-column
                        prop="fileCount"
                        label="File Count (size)">
                      </el-table-column>
                      <el-table-column
                        prop="submit_time"
                        label="Release Date">
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Project Title"
                  prop="project_title"
                  width="200"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                  <template slot-scope="scope">
                    <span class="tablelink" @click="handleProurl(scope.row.project_id)">
                      {{scope.row.project_title}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="ProjectID"
                  prop="project_id"
                  width="122"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Submission Type"
                  prop="submission_type"
                  width="104"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="PXID"
                  prop="px_id"
                  width="98"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Publication"
                  prop="pubmed_id"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                  <template slot-scope="scope">
                    <span>
                      <a :href="publictionUrl+scope.row.pubmed_id" target="_blank">{{scope.row.pubmed_id}}</a>
                      {{scope.row.reference}}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Submitter"
                  prop="submitter"
                  width="114"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Lab Head"
                  prop="lab_header"
                  width="120"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Institution"
                  prop="institution"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Subproject Count"
                  prop="sub_count"
                  width="100"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Releasedate"
                  prop="release_date"
                  width="130"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :total="allNum2"
                :page-size="pageSize2"
                @current-change="handleChangepage2"
                class="pagination mb10">
              </el-pagination>
            </div>
          </el-card>
          <el-card class="box-card mt20" shadow="never" v-show="isShowSub">
            <div slot="header" class="clearfix textLeft">
              <span><i class="fa fa-cogs fs14" /> Subproject Information List</span>
            </div>
            <div class="textLeft">
              Search: <el-input size="medium" v-model="subprosekey2" placeholder="" class="searchInput mr5" clearable></el-input>
              <el-button class="submitbtn" @click="handleSearchsub2">Search</el-button>
              <el-table
                height="500"
                class="mt10"
                empty-text="No Data"
                :data="subprojectData2"
                border
                stripe
                v-loading="loadingsub2"
                @sort-change="handleSortsub2"
                style="width: 100%">
                <el-table-column
                  sortable
                  :show-overflow-tooltip="isOverflow"
                  prop="subproject_name"
                  label="Subproject">
                  <template slot-scope="scope">
                    <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">{{scope.row.subproject_name}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Subproject ID"
                  prop="subproject_id"
                  width="140"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="PXID"
                  prop="px_id"
                  width="140"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  label="Species"
                  prop="species"
                  width="130"
                  sortable
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  prop="instrument"
                  label="Instrument"
                  width="160">
                </el-table-column>
                <el-table-column
                  prop="fileCount"
                  label="File Count (size)"
                  width="160"
                >
                </el-table-column>
                <el-table-column
                  prop="release_date"
                  label="Release Date"
                  width="160"
                  sortable>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :total="allNumsub2"
                :page-size="pageSizesub2"
                @current-change="handleChangepagesub2"
                class="pagination mb10">
              </el-pagination>
            </div>
          </el-card>
          <!-- <div v-for="(item, index) in idenSearchItem" :key="index" class="mb10" style="display: flex">
            <el-select v-model="searchp1_1" placeholder="All Fields" class="searchcss" disabled>
              <el-option label="All Fields" value="1"></el-option>
            </el-select>
            <el-select v-model="searchp1_2" placeholder="All Fields" class="searchcss">
              <el-option
                v-for="item in allFileOpt"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-input placeholder="Search..." v-model="searchinput2" class="input-with-select inputcss mr5" />
            <el-button type="primary" size="small" @click="handleDele2(index)"  v-show="false">Delete<i class="el-icon-close el-icon--right"></i></el-button>
          </div>
          <el-card shadow="never" class="mt10 cardbg">
            <el-row>
              <el-col :span="12">
                <div class="tipdiv">
                  <span class="tipcss">Identification Search</span>(Protein ID,Peptide sequence etc.)<br />You could enter more than one pair of type and value below to conduct this search.
                </div>
              </el-col>
              <el-col :span="12" class="textRight">
                <el-button type="primary" @click="handleAdd2">Add<i class="el-icon-plus el-icon--right"></i></el-button>
                <el-button type="primary" @click="handleSearch2">Search<i class="el-icon-search el-icon--right"></i></el-button>
              </el-col>
            </el-row>
          </el-card> -->
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { getSearchProjectList, getSearchSubProjectList, getSearchSuperProjectList, getCvSampleTypes, getSearchAdvProjectList, getSearchAdvSubProjectList, getSearchAdvSuperProjectList } from '@/api'
  export default {
    name: 'search',
    data() {
      return {
        projectData: [],
        subprojectData: [],
        supprojectData: [],
        prosekey: '',
        subprosekey: '',
        supprosekey: '',
        loading: false,
        loadingsub: false,
        loadingsup: false,
        isOverflow: true,
        allNum: 0,
        pageSize: 20,
        allNumsub: 0,
        pageSizesub: 20,
        allNumsup: 0,
        pageSizesup: 20,
        searchkey: '',
        ajax_datapro: {
          search:{
            global: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: ""
          }
        },
        ajax_datasubpro: {
          search:{
            global: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: ""
          }
        },
        isShowResult: false,
        orderConvert: {
          ascending: 'asc',
          descending: 'desc'
        },
        publictionUrl: 'http://www.ncbi.nlm.nih.gov/pubmed?term=',
        subloading: true,
        expands: [],
        getRowKeys (row) {
          return row.project_id
        },
        expsuploading: true,
        expandssup: [],
        getRowKeyssup (row) {
          return row.sproject_id
        },
        ajax_dataExpsubpro: {
          search:{
            project_id: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 0
          },
          order:{
            item: "",
            type: ""
          }
        },
        ajax_datasuppro: {
          search:{
            global: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: ""
          }
        },
        ajax_dataprosupexp: {
          search:{
            global: "",
            sub: "",
            superproject_id: ''
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: ""
          }
        },
        searchinput1: '',
        search1_1: '1',
        search1_2: '1',
        searchp1_1: '1',
        searchp1_2: '1',
        searchinput2: '',
        searchWayOpt: [{
          value: 'AND',
          label: 'AND'
        }, {
          value: 'OR',
          label: 'OR'
        }],
        allFileOpt: [
          {
            value: 'all',
            label: 'All Fields'
          }, {
            value: 'project_id',
            label: 'Project ID'
          }, {
            value: 'px_id',
            label: 'PXID'
          }, {
            value: 'project_title',
            label: 'Project Title'
          }, {
            value: 'institution',
            label: 'Institution'
          }, {
            value: 'submitter',
            label: 'Submitter'
          }, {
            value: 'reference',
            label: 'Reference'
          }, {
            value: 'pubmed_id',
            label: 'PubMed ID'
          }, {
            value: 'subproject_id',
            label: 'Subproject ID'
          }, {
            value: 'subproject_title',
            label: 'Subproject Title'
          }, {
            value: 'species',
            label: 'Species'
          }, {
            value: 'tissue',
            label: 'Tissue'
          }, {
            value: 'cell',
            label: 'Cell'
          }, {
            value: 'disease',
            label: 'Disease'
          }, {
            value: 'quantification',
            label: 'Quantification'
          }, {
            value: 'digestion',
            label: 'Digestion'
          }, {
            value: 'ptm',
            label: 'PTMs'
          }, {
            value: 'instrument',
            label: 'MSInstrument'
          }, {
            value: 'sproject_id',
            label: 'Super Project ID'
          }, {
            value: 'sproject_name',
            label: 'Super Project Name'
          }
        ],
        searchItems: [
          { id: 1, isShowAll: true, isShowway: false, isShowsele: false, searchway: 'AND', searchfile: 'all', searchSele: '', searchinput: '' }
        ],
        idenSearchItem: [
          { id: 1, searchfile: '1', searchinput: '' }
        ],
        changeSelecVal: ['species', 'tissue', 'cell', 'disease', 'quantification', 'digestion', 'ptm', 'instrument'],
        SeleOpt: [],
        ajax_dataSam: {
          search:{
            sample_type: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 0
          },
          order:{
            item: "",
            type: ""
          }
        },
        searchProarr: ['project_id', 'px_id', 'project_title', 'institution', 'submitter', 'reference', 'pubmed_id'],
        searchsubProarr: ['subproject_id', 'subproject_title', 'species', 'tissue', 'cell', 'disease', 'quantification', 'digestion', 'ptm', 'instrument'],
        searchsupProarr: ['sproject_id', 'sproject_name'],
        projectData2: [],
        subprojectData2: [],
        supprojectData2: [],
        prosekey2: '',
        subprosekey2: '',
        supprosekey2: '',
        loading2: false,
        loadingsub2: false,
        loadingsup2: false,
        isOverflow2: true,
        allNum2: 0,
        pageSize2: 20,
        allNumsub2: 0,
        pageSizesub2: 20,
        allNumsup2: 0,
        pageSizesup2: 20,
        subloading2: true,
        expands2: [],
        getRowKeys2 (row) {
          return row.project_id
        },
        expsuploading2: true,
        expandssup2: [],
        getRowKeyssup2 (row) {
          return row.sproject_id
        },
        isShowSup: false,
        isShowPro: false,
        isShowSub: false,
        ajax_dataadvpro: {
          filters: [],
          page:{
            pageNum: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: "ascending"
          }
        },
        ajax_dataadvsup: {
          filters: [],
          page:{
            pageNum: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: "ascending"
          }
        },
        ajax_dataadvsub: {
          filters: [],
          page:{
            pageNum: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: "ascending"
          }
        }
      }
    },
    mounted() {
      if( this.$route.query.sval && this.$route.query.sval != '' ){
        this.searchkey = this.$route.query.sval
        this.handleSearch()
      }
    },
    methods: {
      handleProurl(param) {
        let routerData = this.$router.resolve({path: '/project', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      handlesubProurl(param) {
        let routerData = this.$router.resolve({path: '/subproject', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      handlesupProurl(param) {
        let routerData = this.$router.resolve({path: '/supproject', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      handleSearch() {
        console.log(this.searchkey)
        this.isShowResult = true
        this.loading = true
        this.loadingsub = true
        this.ajax_datapro.search.global = this.searchkey
        this.ajax_datapro.search.sub = this.prosekey
        getSearchProjectList(this.ajax_datapro).then(res => {
          this.loading = false
          this.projectData = res.result
          this.allNum = res.count
        })
        this.ajax_datasubpro.search.global = this.searchkey
        this.ajax_datasubpro.search.sub = this.prosekey
        getSearchSubProjectList(this.ajax_datasubpro).then(res => {
          this.loadingsub = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          this.subprojectData = newData
          this.allNumsub = res.count
        })
        this.loadingsup = true
        this.ajax_datasuppro.search.global = this.searchkey
        this.ajax_datasuppro.search.sub = this.supprosekey
        getSearchSuperProjectList(this.ajax_datasuppro).then(res => {
          this.loadingsup = false
          this.supprojectData = res.result
          this.allNumsup = res.count
        })
      },
      handleSearchpro() {
        this.loading = true
        this.ajax_datapro.search.global = this.searchkey
        this.ajax_datapro.search.sub = this.prosekey
        getSearchProjectList(this.ajax_datapro).then(res => {
          this.loading = false
          this.projectData = res.result
          this.allNum = res.count
        })
      },
      handleSearchsub() {
        this.loadingsub = true
        this.ajax_datasubpro.search.global = this.searchkey
        this.ajax_datasubpro.search.sub = this.subprosekey
        getSearchSubProjectList(this.ajax_datasubpro).then(res => {
          this.loadingsub = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          this.subprojectData = newData
          this.allNumsub = res.count
        })
      },
      handleChangepage (val) {
        this.loading = true
        this.ajax_datapro.page.startPage = val
        getSearchProjectList(this.ajax_datapro).then(res => {
          this.loading = false
          this.projectData = res.result
          this.allNum = res.count
        })
      },
      handleChangepagesub (val) {
        this.loadingsub = true
        this.ajax_datasubpro.page.startPage = val
        getSearchSubProjectList(this.ajax_datasubpro).then(res => {
          this.loadingsub = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          this.subprojectData = newData
          this.allNumsub = res.count
        })
      },
      handleSort (column, prop, order) {
        // console.log(column, prop, order)
        this.loading = true
        this.ajax_datapro.order.item = column.prop
        this.ajax_datapro.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getSearchProjectList(this.ajax_datapro).then(res => {
            this.loading = false
            this.projectData = res.result
            this.allNum = res.count
          })
        } else {
          this.loading = false
        }
      },
      handleSortsub (column, prop, order) {
        // console.log(column, prop, order)
        this.loadingsub = true
        this.ajax_datasubpro.order.item = column.prop
        this.ajax_datasubpro.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getSearchSubProjectList(this.ajax_datasubpro).then(res => {
            this.loadingsub = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            this.subprojectData = newData
            this.allNumsub = res.count
          })
        } else {
          this.loadingsub = false
        }
      },
      handleExpand(row, expandedRows) {
        this.subloading = true
        // console.log(row, expandedRows)
        this.expands = []
        if (expandedRows.length) {
          expandedRows.map((item, key) => {
            this.expands.push(item.project_id)
          })
          this.ajax_dataExpsubpro.search.project_id = row.project_id
          this.ajax_dataExpsubpro.search.sub = this.subprosekey
          this.ajax_dataExpsubpro.page.startPage = 1
          getSearchSubProjectList(this.ajax_dataExpsubpro).then(res => {
            this.subloading = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            let subList = newData
            // console.log(subList)
            row.subtableData = subList
          })
        } else {
          this.expands = []
        }
      },
      handleSearchsuppro() {
        this.loadingsup = true
        this.ajax_datasuppro.search.global = this.searchkey
        this.ajax_datasuppro.search.sub = this.supprosekey
        getSearchSuperProjectList(this.ajax_datasuppro).then(res => {
          this.loadingsup = false
          this.supprojectData = res.result
          this.allNumsup = res.count
        })
      },
      handleChangepagesup (val) {
        this.loadingsup = true
        this.ajax_datasuppro.page.startPage = val
        getSearchSuperProjectList(this.ajax_datasuppro).then(res => {
          this.loadingsup = false
          this.supprojectData = res.result
          this.allNumsup = res.count
        })
      },
      handleSortsup (column, prop, order) {
        this.loadingsup = true
        this.ajax_datasuppro.order.item = column.prop
        this.ajax_datasuppro.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getSearchSuperProjectList(this.ajax_datasuppro).then(res => {
            this.loadingsup = false
            this.supprojectData = res.result
            this.allNumsup = res.count
          })
        } else {
          this.loadingsup = false
        }
      },
      handleExpandsup(row, expandedRows) {
        this.expsuploading = true
        // console.log(row, expandedRows)
        this.expandssup = []
        if (expandedRows.length) {
          expandedRows.map((item, key) => {
            this.expandssup.push(item.sproject_id)
          })
          this.ajax_dataprosupexp.search.superproject_id = row.sproject_id
          this.ajax_dataprosupexp.search.sub = this.supprosekey
          this.ajax_dataprosupexp.page.startPage = 1
          getSearchProjectList(this.ajax_dataprosupexp).then(res => {
            this.expsuploading = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            let subList = newData
            // console.log(subList)
            row.suptableData = subList
          })
        } else {
          this.expandssup = []
        }
      },
      handleFilesize(param) {
        let fileSize = param;
        if (fileSize == 0 || fileSize == null) {
          fileSize = ' (' + 0 +'K)';
        } else if (fileSize < 1024) {
          fileSize = ' (' + fileSize.toFixed(2) + 'K)';
        } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
          fileSize =  ' (' + (fileSize / 1024).toFixed(2)+ 'M)'
        } else {
          fileSize =   ' ('
            + (fileSize / 1024 / 1024).toFixed(2)
            + 'G)'
        }
        return fileSize
      },
      handleAdd1() {
        let counts = Object.keys(this.searchItems).length
        let lengthobg = counts+1
        console.log(counts)
        this.searchItems.push({
          id: lengthobg, isShowAll:false, isShowway: true, isShowsele: false, searchway: 'AND', searchfile: 'all', searchSele: '', searchinput: ''
        })
      },
      handleSearch1() {
        console.log(this.searchItems)
        let allcount = 0
        this.searchItems.map((item, key) => {
          if(item.searchfile != 'all') {
            allcount += 1
          }
        })
        if(allcount == 0) {
          this.getadvPro('')
          this.getadvSup('')
          this.getadvSub('')
          this.isShowPro = true
          this.isShowSup = true
          this.isShowSub = true
        } else {
          let procount = 0
          let supcount = 0
          let subcount = 0
          this.searchItems.map((item, key) => {
            if(this.searchProarr.includes(item.searchfile)) {
              procount += 1
            } else if(this.searchsubProarr.includes(item.searchfile)) {
              subcount += 1
            } else if(this.searchsupProarr.includes(item.searchfile)) {
              supcount += 1
            }
          })
          if(procount != 0) {
            this.getadvPro(this.searchItems)
            this.isShowPro = true
            this.isShowSub = false
            this.isShowSup = false
          } else if(subcount != 0) {
            this.getadvSub(this.searchItems)
            this.isShowSub = true
            this.isShowPro = false
            this.isShowSup = false
          } else if(supcount != 0) {
            this.getadvSup(this.searchItems)
            this.isShowSup = true
            this.isShowPro = false
            this.isShowSub = false
          }
        }
      },
      handleDele1(index) {
        if (index !== 0) {
          this.searchItems.splice(index, 1)
        }
        // if (this.searchItems.length > 1) {
        //   this.searchItems.splice(index, 1)
        // }
      },
      handleReset1(){
        this.searchItems = [
          { id: 1, isShowAll: true, isShowway: false, isShowsele: false, searchway: 'AND', searchfile: 'all', searchSele: '', searchinput: '' }
        ]
      },
      handleKind(itemArr,index) {
        console.log(itemArr,index)
        if(this.changeSelecVal.includes(itemArr.searchfile)) {
          this.searchItems[index].isShowsele = true
          this.searchItems[index].searchSele = ''
          this.searchItems[index].searchinput = ''
          this.ajax_dataSam.search.sample_type = itemArr.searchfile
          getCvSampleTypes(this.ajax_dataSam).then(res => {
            this.SeleOpt = res.result
          })
        } else {
          this.searchItems[index].isShowsele = false
          this.searchItems[index].searchSele = ''
          this.searchItems[index].searchinput = ''
        }
      },
      getadvPro(param) {
        if(param == '') {
          this.loading2 = true
          getSearchAdvProjectList(this.ajax_dataadvpro).then(res => {
            this.loading2 = false
            this.projectData2 = res.result
            this.allNum2 = res.count
          })
        } else {
          this.ajax_dataadvpro.filters = []
          this.loading2 = true
          this.searchItems.map((item, key) => {
            let ajaxarr
            if(this.changeSelecVal.includes(item.searchfile)) {
              ajaxarr = {item: item.searchfile, like: item.searchSele, opt: item.searchway}
            } else {
              let inputval = item.searchinput.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
              ajaxarr = {item: item.searchfile, like: inputval, opt: item.searchway}
            }
            this.ajax_dataadvpro.filters.push(ajaxarr)
          })
          console.log(this.ajax_dataadvpro)
          getSearchAdvProjectList(this.ajax_dataadvpro).then(res => {
            this.loading2 = false
            this.projectData2 = res.result
            this.allNum2 = res.count
          })
        }
      },
      getadvSup(param) {
        if(param == '') {
          this.loadingsup2 = true
          getSearchAdvSuperProjectList(this.ajax_dataadvsup).then(res => {
            this.loadingsup2 = false
            this.supprojectData2 = res.result
            this.allNumsup2 = res.count
          })
        } else {
          this.ajax_dataadvsup.filters = []
          this.loadingsup2 = true
          this.searchItems.map((item, key) => {
            let ajaxarr
            if(this.changeSelecVal.includes(item.searchfile)) {
              ajaxarr = {item: item.searchfile, like: item.searchSele, opt: item.searchway}
            } else {
              let inputval = item.searchinput.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
              ajaxarr = {item: item.searchfile, like: inputval, opt: item.searchway}
            }
            this.ajax_dataadvsup.filters.push(ajaxarr)
          })
          console.log(this.ajax_dataadvsup)
          getSearchAdvSuperProjectList(this.ajax_dataadvsup).then(res => {
            this.loadingsup2 = false
            this.supprojectData2 = res.result
            this.allNumsup2 = res.count
          })
        }
      },
      getadvSub(param) {
        if(param == '') {
          this.loadingsub2 = true
          getSearchAdvSubProjectList(this.ajax_dataadvsub).then(res => {
            this.loadingsub2 = false
            this.subprojectData2 = res.result
            this.allNumsub2 = res.count
          })
        } else {
          this.ajax_dataadvsub.filters = []
          this.loadingsub2 = true
          this.searchItems.map((item, key) => {
            let ajaxarr
            if(this.changeSelecVal.includes(item.searchfile)) {
              ajaxarr = {item: item.searchfile, like: item.searchSele, opt: item.searchway}
            } else {
              let inputval = item.searchinput.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
              ajaxarr = {item: item.searchfile, like: inputval, opt: item.searchway}
            }
            this.ajax_dataadvsub.filters.push(ajaxarr)
          })
          console.log(this.ajax_dataadvsub)
          getSearchAdvSubProjectList(this.ajax_dataadvsub).then(res => {
            this.loadingsub2 = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            this.subprojectData2 = newData
            this.allNumsub2 = res.count
          })
        }
      },
      handleSearchpro2() {
        this.loading2 = true
        let subcount = 0
        this.ajax_dataadvpro.filters.map((Itemarr, key) => {
          if(Itemarr.item == 'sub') {
            subcount += 1
            Itemarr.like = this.prosekey2
          }
        })
        if(subcount == 0) {
          let searchobj = {item: 'sub', like: this.prosekey2, opt: 'AND'}
          this.ajax_dataadvpro.filters.push(searchobj)
        }
        getSearchAdvProjectList(this.ajax_dataadvpro).then(res => {
          this.loading2 = false
          this.projectData2 = res.result
          this.allNum2 = res.count
        })
      },
      handleSearchsub2() {
        this.loadingsub2 = true
        let subcount = 0
        this.ajax_dataadvsub.filters.map((Itemarr, key) => {
          if(Itemarr.item == 'sub') {
            subcount += 1
            Itemarr.like = this.subprosekey2
          }
        })
        if(subcount == 0) {
          let searchobj = {item: 'sub', like: this.subprosekey2, opt: 'AND'}
          this.ajax_dataadvsub.filters.push(searchobj)
        }
        getSearchAdvSubProjectList(this.ajax_dataadvsub).then(res => {
          this.loadingsub2 = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          this.subprojectData2 = newData
          this.allNumsub2 = res.count
        })
      },
      handleChangepage2(val) {
        this.loading2 = true
        this.ajax_dataadvpro.page.pageNum = val
        getSearchAdvProjectList(this.ajax_dataadvpro).then(res => {
          this.loading2 = false
          this.projectData2 = res.result
          this.allNum2 = res.count
        })
      },
      handleChangepagesub2(val) {
        this.loadingsub2 = true
        this.ajax_dataadvsub.page.pageNum = val
        getSearchAdvSubProjectList(this.ajax_dataadvsub).then(res => {
          this.loadingsub2 = false
          this.projectData2 = res.result
          this.allNumsub2 = res.count
        })
      },
      handleSort2 (column, prop, order) {
        // console.log(column, prop, order)
        this.loading2 = true
        this.ajax_dataadvpro.order.item = column.prop
        this.ajax_dataadvpro.order.type = column.order
        if (column.order !== null && column.prop !== null) {
          getSearchAdvProjectList(this.ajax_dataadvpro).then(res => {
            this.loading2 = false
            this.projectData2 = res.result
            this.allNum2 = res.count
          })
        } else {
          this.loading2 = false
        }
      },
      handleSortsub2 (column, prop, order) {
        // console.log(column, prop, order)
        this.loadingsub2 = true
        this.ajax_dataadvsub.order.item = column.prop
        this.ajax_dataadvsub.order.type = column.order
        if (column.order !== null && column.prop !== null) {
          getSearchAdvSubProjectList(this.ajax_dataadvsub).then(res => {
            this.loadingsub2 = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            this.subprojectData2 = newData
            this.allNumsub2 = res.count
          })
        } else {
          this.loadingsub2 = false
        }
      },
      handleExpand2(row, expandedRows) {
        this.subloading2 = true
        // console.log(row, expandedRows)
        this.expands2 = []
        if (expandedRows.length) {
          expandedRows.map((item, key) => {
            this.expands2.push(item.project_id)
          })
          this.ajax_dataExpsubpro.search.project_id = row.project_id
          this.ajax_dataExpsubpro.search.sub = this.subprosekey2
          this.ajax_dataExpsubpro.page.startPage = 1
          getSearchSubProjectList(this.ajax_dataExpsubpro).then(res => {
            this.subloading2 = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            let subList = newData
            // console.log(subList)
            row.subtableData2 = subList
          })
        } else {
          this.expands2 = []
        }
      },
      handleSearchsuppro2() {
        this.loadingsup2 = true
        let subcount = 0
        this.ajax_dataadvsup.filters.map((Itemarr, key) => {
          if(Itemarr.item == 'sub') {
            subcount += 1
            Itemarr.like = this.supprosekey2
          }
        })
        if(subcount == 0) {
          let searchobj = {item: 'sub', like: this.supprosekey2, opt: 'AND'}
          this.ajax_dataadvsup.filters.push(searchobj)
        }
        getSearchAdvSuperProjectList(this.ajax_dataadvsup).then(res => {
          this.loadingsup2 = false
          this.supprojectData2 = res.result
          this.allNumsup2 = res.count
        })
      },
      handleChangepagesup2() {
        this.loadingsup2 = true
        this.ajax_dataadvsup.page.pageNum = val
        getSearchAdvSuperProjectList(this.ajax_dataadvsup).then(res => {
          this.loadingsup2 = false
          this.supprojectData2 = res.result
          this.allNumsup2 = res.count
        })
      },
      handleSortsup2 (column, prop, order) {
        this.loadingsup2 = true
        this.ajax_datasuppro.order.item = column.prop
        this.ajax_datasuppro.order.type = column.order
        if (column.order !== null && column.prop !== null) {
          getSearchAdvSuperProjectList(this.ajax_datasuppro).then(res => {
            this.loadingsup2 = false
            this.supprojectData2 = res.result
            this.allNumsup2 = res.count
          })
        } else {
          this.loadingsup2 = false
        }
      },
      handleExpandsup2(row, expandedRows) {
        this.expsuploading2 = true
        // console.log(row, expandedRows)
        this.expandssup2 = []
        if (expandedRows.length) {
          expandedRows.map((item, key) => {
            this.expandssup2.push(item.sproject_id)
          })
          this.ajax_dataprosupexp.search.superproject_id = row.sproject_id
          this.ajax_dataprosupexp.search.sub = this.supprosekey2
          this.ajax_dataprosupexp.page.startPage = 1
          getSearchProjectList(this.ajax_dataprosupexp).then(res => {
            this.expsuploading2 = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            let subList = newData
            // console.log(subList)
            row.suptableData2 = subList
          })
        } else {
          this.expandssup2 = []
        }
      }
      // handleAdd2() {
      //   let counts = Object.keys(this.idenSearchItem).length
      //   let lengthobg = counts+1
      //   console.log(counts)
      //   this.idenSearchItem.push({
      //     id: lengthobg, searchfile: '1', searchinput: ''
      //   })
      // },
      // handleSearch2() {
      //   console.log(this.idenSearchItem)
      // },
      // handleDele2(index) {
      //   if (this.idenSearchItem.length > 1) {
      //     this.idenSearchItem.splice(index, 1)
      //   }
      // }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search {
  .searchcss {
    width: 10%;
  }
  .inputcss {
    width: 80%;
  }
  .cardbg {
    background-color: #dff0d8;
    border-color: #d6e9c6;
    color: #3c763d;
  }
  .tipdiv {
    line-height: 23px;
  }
  .tipcss {
    color: red;
    font-weight: bold;
  }
  .selwidth {
    width: 100%;
  }
}
</style>
